module.exports = __webpack_public_path__ + "static/img/Starter_Mobile_1.f21fbf7d.svg";